import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import React, { Component } from 'react';
import firebase from 'firebase';
import Modal from 'react-modal';
import { Link } from 'react-router-dom';
import ReactExport from "react-data-export"
import Report from '../Reportes/repoViaje'
import Emple from '../views/empledo'
import './modal.css';
import Slide from '../Globals/Slide/slide'
import store from '../../store';
import { getAuth } from '../config/Paths'

const database = firebase.database();

const customStyles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		transform: 'translate(-50%, -50%)',
		width: '450px',
		height: '450px',
		padding: "0px",

	}
};
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

class Viajes extends Component {

	constructor(props) {

		super(props)
		this.state = {
			viajes: [],
			viajestemp: [],
			clientes: [],
			viajes: [],
			empleados: [],
			costoD: [],
			vehiculosD: [],
			empresa: [],
			fecha_actual: '',
			fecha_minima: '',
			input_disabled: 'disabled',
			isLoading: false,
			modalIsOpen: false,
			modalIsOpenC: false,
			EmpleActu: [],



			clienteR: [],
			centroR: [],
			ViajesR: [],
			empleadosR: [],
			vehiculosR: [],
			empresaR:[],
			empreUID: []

		}

		this.clientesRef = database.ref().child('Clientes').orderByChild('socio').equalTo(firebase.auth().currentUser.uid);
		this.viajesRef = database.ref().child('Viaje');
		this.empleadosRef = database.ref().child('Empleados');
		this.costosRef = database.ref().child('CentroCosto');
		this.vehiculosRef = database.ref().child('Vehiculos');
		this.empresaRef = database.ref().child('Empresa');
		this.handleChangeDatePicker1 = this.handleChangeDatePicker1.bind(this);
		this.handleChangeDatePicker2 = this.handleChangeDatePicker2.bind(this);
		this.mostrarRegistrosHoy = this.mostrarRegistrosHoy.bind(this);



		let f = new Date();

		this.state.fecha_actual = f.getFullYear() + '-' + ((f.getMonth() + 1) > 10 ? f.getMonth : '0' + (f.getMonth() + 1)) + '-' + (f.getDate() > 10 ? f.getDate() : '0' + f.getDate());



	}

	componentWillMount() {
		let empreUID = firebase.auth().currentUser.uid;
		this.setState({ empreUID })
	}


	componentDidMount() {

		this.costosRef.once('value').then(this.gotCostos, this.errDataCosos);
		this.empresaRef.once('value').then(this.gotEmpresa, this.errDataEmpresa);
		this.vehiculosRef.once('value').then(this.gotVehiculos, this.errDataVehi);
		this.empleadosRef.once('value').then(this.gotDataEmpleados, this.errDataEmpleados);
		this.clientesRef.once('value').then(this.gotDataClientes, this.errDataClientes);
		this.viajesRef.once('value').then(this.gotDataViajes, this.errDataViajes);



		this.getData();
	}


	getData = () => {
		let { empreUID } = this.state
		firebase.database().ref().child('AsignacionViajes').orderByChild('solicitante').equalTo(empreUID).once('value').then(snapV => {
			let datosV = [];
			snapV.forEach(elementCli => {
				let objeC = elementCli.val();
				objeC.key = elementCli.key;
				datosV.push(objeC);
			});
			firebase.database().ref('Empleados').once('value').then(snapE => {
				let datosE = [];
				snapE.forEach(elementCli => {
					let objeC = elementCli.val();
					objeC.key = elementCli.key;
					datosE.push(objeC);
				});
				firebase.database().ref('Vehiculos').once('value').then(snapVe => {
					let datosVe = [];
					snapVe.forEach(elementCli => {
						let objeC = elementCli.val();
						objeC.key = elementCli.key;
						datosVe.push(objeC);
					});
					firebase.database().ref().child('Clientes').orderByChild('socio').equalTo(empreUID).once('value').then(snapC => {
						let datosC = [];
						snapC.forEach(elementCli => {
							let objeC = elementCli.val();
							objeC.key = elementCli.key;
							datosC.push(objeC);
						});
						firebase.database().ref().child('CentroCosto').orderByChild('empresa').equalTo(empreUID).once('value').then(snapCo => {
							let datosCo = [];
							snapCo.forEach(elementCli => {
								let objeC = elementCli.val();
								objeC.key = elementCli.key;
								datosCo.push(objeC);
							});
							this.setState({
								clienteR: datosC,
								centroR: datosCo,
								ViajesR: datosV,
								empleadosR: datosE,
								vehiculosR: datosVe,
							})
							firebase.database().ref('Empresa/'+empreUID).once('value').then(snapEmp =>{
								let empresa = snapEmp.val();
								this.setState({empresaR:empresa})
								this.cargarViajesEmpresariales();
							})
						})
					})
				})
			})
		})
	}

	async cargarViajesEmpresariales() {
		let { clienteR, centroR, ViajesR, empleadosR, vehiculosR, empresaR } = this.state;
		let mostrar = [];
		for (let index = 0; index < ViajesR.length; index++) {
			let viajes = ViajesR[index];
			[viajes.emple].forEach(element => {
				let cantidadP = Object.keys(element).length;
				let encontrardoConduct = '';
				let costo = [];
				let area = [];
				let responsable = [];
				let encontrardoVehiculo = '';
				let clientesN = [];
				let fechaI = '';
				let fechaA = [];
				let fechaB = [];
				let fechaF = '';
				let desde = '';
				let hacia = [];
				let tarifaA = '';
				let precioA = '';
				let Solicito = '';
				let codClie = [];
				desde = viajes.inicio;
				let fInicial = new Date(viajes.horaIni);
				let fFinal = new Date(viajes.horaFin);
				fechaI = fInicial.getFullYear() + '-' + (fInicial.getMonth() + 1) + '-' + fInicial.getDate()  + ' ' + fInicial.getHours() + ':' + fInicial.getSeconds();
				fechaF = fFinal.getFullYear() + '-' + (fFinal.getMonth() + 1) + '-' + fFinal.getDate() + ' ' + fFinal.getHours() + ':' + fFinal.getSeconds();
				if (viajes.destino !== undefined) {
					hacia.push(viajes.destino);
				}
				for (let index = 0; index < cantidadP; index++) {
					let objeCli = element[Object.keys(element)[index]];//importante
					let encontrardoClie = clienteR.find(client => {
						return objeCli.idEmple === client.key;
					})
					clientesN.push(encontrardoClie.nombre)
					codClie.push(encontrardoClie.numero_empleado)
					area.push(encontrardoClie.areaDesc)
					let fecha1 = new Date(objeCli.horaSubida)
					fechaA.push(fecha1.getHours() + ':' + fecha1.getMinutes())
					let fecha2 = new Date(objeCli.horaBajada)
					fechaB.push(fecha2.getHours() + ':' + fecha2.getMinutes())
					if (viajes.destino === undefined) {
						hacia.push(objeCli.destino);	
					}
					let encontrardoCosto = centroR.find(client => {
						return encontrardoClie.centro === client.key;
					})
					costo.push(encontrardoCosto.codigo);
					responsable.push(encontrardoCosto.responsable);
				}
				encontrardoConduct = empleadosR.find(emple => {
					return viajes.conduc === emple.key;
				})
				encontrardoVehiculo = vehiculosR.find(vehi => {
					return encontrardoConduct.vehiculo === vehi.key;
				})

				let objeT={
					key: viajes.key,
					cliente: empresaR.codigo_empresa,
					empleado: encontrardoConduct.nombre,
					fechaReserva: fechaI,
					fechaBajada: fechaF,
					fechaSubida: fechaI,
					horaSubida: fechaA.join(','),
					horaBajada: fechaB.join(','),
					pago:'',
					total:'',
					desde: desde,
					lugar: hacia.join('?'),
					combinacion: '',
					tipoV:encontrardoConduct.tipo_vehiculo,
					foto:encontrardoConduct.foto,
					keyEmpleado:encontrardoConduct.key,
					detaCate: '#N/A',
					areaDesc:area.join(','),
					cantTrayec: cantidadP,
					numero:cantidadP,
					numero_empleado:cantidadP,
					centro:costo.join(','),
					responsable:responsable.join(','),
					vehiculo:encontrardoVehiculo.placa,
					personas:clientesN.join(','),
					numero_empleado:codClie.join(','),
					pago:'Empresa'
				}
				mostrar.push(objeT);
			});
		};
		let index = 0;
		mostrar.forEach(element => {
			let destinos = [];
			let inicio ='';
			let detinos = element.lugar.split('?')
			detinos.forEach(element2 => {
				const proxyurl = "https://cors-anywhere.herokuapp.com/";
				fetch(proxyurl+'https://maps.googleapis.com/maps/api/directions/json?origin='+element.desde+'&destination='+element2+'&key=AIzaSyATad9mdS85bZPesVOnJpSP3BSwVAg60aY', getAuth() )
				.then( response => response.json())
				.then(responseJSON =>{
					if(responseJSON.routes[0] !== undefined){
						destinos.push(responseJSON.routes[0].legs[0].end_address)
						inicio = responseJSON.routes[0].legs[0].start_address
					}
				})
			});	
			setTimeout(() => {
				mostrar[index].lugar = destinos.join('|')
				mostrar[index].desde = inicio;
				mostrar[index].combinacion = inicio+' => '+destinos.join('|');
				this.setState({
					viajes: [...this.state.viajes,mostrar[index]],
					viajestemp: [...this.state.viajestemp,mostrar[index]]
				})
				index = index + 1;
			}, 1500);
		});
	}
	 


	ocultarMenu() {
		store.dispatch({
			type: 'STATE_MOSTRAR',
			mostrar: 'noMostrar'
		})
	}

	gotEmpresa = (data) => {
		let Datos = [];
		const Base = data.val();
		if (Base != null) {
			const keys = Object.keys(Base);
			for (let i = 0; i < keys.length; i++) {
				const k = keys[i];
				Datos.push({
					key: k,
					nombre: Base[k].codigo_empresa
				})
			}
			this.setState({ empresa: Datos });
		}
	}
	errDataEmpresa = (err) => {

		console.log(err);

	}

	gotVehiculos = (data) => {
		let Datos = [];
		const Base = data.val();
		if (Base != null) {
			const keys = Object.keys(Base);
			for (let i = 0; i < keys.length; i++) {
				const k = keys[i];
				Datos.push({
					key: k,
					placa: Base[k].placa,
					tipo: Base[k].tipo_vehiculo
				})
			}
			this.setState({ vehiculosD: Datos });
		}
	}
	errDataVehi = (err) => {

		console.log(err);

	}

	gotDataClientes = (data) => {



		let newClientes = []

		if (data.val() !== null) {


			let clientesdata = data.val();
			let keys = Object.keys(clientesdata);


			for (let i = 0; i < keys.length; i++) {

				let k = keys[i];

				newClientes.push({
					key: k,
					apellido: clientesdata[k].apellido,
					nombre: clientesdata[k].nombre,
					correo: clientesdata[k].correo,
					estado: clientesdata[k].estado,
					centro: clientesdata[k].centro,
					numero_empleado: clientesdata[k].numero_empleado,
					areaDesc: clientesdata[k].areaDesc,
				})

			}
			this.setState({
				clientes: newClientes
			})
		}
	}
	errDataClientes = (err) => {

		console.log(err);

	}

	gotCostos = (data) => {
		let Datos = [];
		const Base = data.val();
		if (Base != null) {
			const keys = Object.keys(Base);
			for (let i = 0; i < keys.length; i++) {
				const k = keys[i];
				Datos.push({
					key: k,
					codigo: Base[k].codigo,
					descripcion: Base[k].descripcion,
					responsable: Base[k].responsable,
					area: Base[k].area
				})
			}
			this.setState({ costoD: Datos });
		}
	}
	errDataCosos = (err) => {

		console.log(err);

	}


	gotDataViajes = (data) => {



		let newViajes = []

		if (data.val() !== null) {

			let dataViajes = data.val();
			let keys = Object.keys(dataViajes);


			for (let i = 0; i < keys.length; i++) {

				let k = keys[i]


				let ingresar = false;
				let cliente;
				let empleado;
				let centro;
				let encargado;
				let vehiculo;
				let nemple;
				let tipoV;
				let foto;
				let areaDesc;
				let keyEmpleado;

				for (let j = 0; j < this.state.clientes.length; j++) {

					if (dataViajes[k].cliente === this.state.clientes[j].key) {

						cliente = this.state.clientes[j].nombre + ' ' + this.state.clientes[j].apellido;
						areaDesc = this.state.clientes[j].areaDesc;
						nemple = this.state.clientes[j].numero_empleado + '' + '';

						for (let r = 0; r < this.state.costoD.length; r++) {

							if (this.state.clientes[j].centro + '' + '' === this.state.costoD[r].key) {

								centro = this.state.costoD[r].codigo + '' + '';
								encargado = this.state.costoD[r].responsable + '' + '';
							}

						}
						ingresar = true;
					}

				}




				if (dataViajes[k].fechaBajada !== undefined && ingresar) {

					for (let h = 0; h < this.state.empleados.length; h++) {

						if (dataViajes[k].empleado === this.state.empleados[h].key) {

							empleado = this.state.empleados[h].nombre;
							tipoV = this.state.empleados[h].tipo_vehiculo;
							foto = this.state.empleados[h].foto;
							keyEmpleado = this.state.empleados[h].key;


							for (let r = 0; r < this.state.vehiculosD.length; r++) {


								if (this.state.empleados[h].vehiculo === this.state.vehiculosD[r].key) {
									vehiculo = this.state.vehiculosD[r].placa;
								}
							}

						}

					}
					if (dataViajes[k].bajarCliente === true) {
						let texto = String(dataViajes[k].lugar);
						let valor = texto.replace("San Salvador,", "")
						valor = valor.replace("de El Salvador", "")
						valor = valor.replace("El Salvador", "")
						valor = valor.replace("Centro Comercial", "")
						valor = valor.replace(",", "")

						let texto2 = String(dataViajes[k].partida);
						let valor2 = texto2.replace("San Salvador,", "")
						valor2 = valor2.replace("de El Salvador", "")
						valor2 = valor2.replace("El Salvador", "")
						valor2 = valor2.replace("Centro Comercial", "")
						valor2 = valor2.replace(",", "")
						newViajes.push({
							key: k,
							cliente: cliente,
							empleado: empleado,
							fechaReserva: dataViajes[k].fechaReserva.substring(0, 10),
							fechaBajada: dataViajes[k].fechaBajada.substring(0, 10),
							fechaSubida: dataViajes[k].fechaSubida.substring(0, 10),
							horaSubida: dataViajes[k].fechaSubida.substring(11, 16),
							horaBajada: dataViajes[k].fechaBajada.substring(11, 16),
							pago: dataViajes[k].pago,
							total: dataViajes[k].total,
							lugar: dataViajes[k].lugar,
							centro: centro,
							responsable: encargado,
							vehiculo: vehiculo,
							numero_empleado: nemple,
							numero: 1,
							personas: cliente,
							lugar: valor,
							desde: valor2,
							combinacion: valor2 + '-' + valor,
							tipoV,
							foto,
							keyEmpleado,
							detaCate: '#N/A',
							cantTrayec: 1,
							areaDesc

						})
					}

				}

			}
			this.setState({
				viajes: newViajes,
				viajestemp: newViajes

			})
		}

	}
	errDataViajes = (err) => {

		console.log(err);

	}

	gotDataEmpleados = (data) => {



		let newEmpleados = []

		if (data.val() !== null) {

			let dataEmpleados = data.val();
			let keys = Object.keys(dataEmpleados);


			for (let i = 0; i < keys.length; i++) {

				let k = keys[i]

				newEmpleados.push({
					key: k,
					estado: dataEmpleados[k].estado,
					nombre: dataEmpleados[k].nombre,
					vehiculo: dataEmpleados[k].vehiculo,
					socio: dataEmpleados[k].socio,
					tipo_vehiculo: dataEmpleados[k].tipo_vehiculo,
					foto: dataEmpleados[k].foto,

				})

			}
			this.setState({ empleados: newEmpleados })
		}

	}
	errDataEmpleados = (err) => {

		console.log(err);

	}


	handleChangeDatePicker1() {


		let fecha1 = this.fecha1.value;


		this.fecha2.value = "";

		this.setState({

			fecha_minima: fecha1,
			input_disabled: ''
		})

	}


	handleChangeDatePicker2() {

		let fecha1 = this.fecha1.value;
		let fecha2 = this.fecha2.value;


		let f1 = new Date(fecha1);
		let f2 = new Date(fecha2);


		let newViajes = []

		this.state.viajes = this.state.viajestemp;
		this.setState({

			viajes: this.state.viajestemp
		})


		for (let i = 0; i < this.state.viajes.length; i++) {


			if (f1.getTime() <= (new Date(this.state.viajes[i].fechaBajada)).getTime() && f2.getTime() >= (new Date(this.state.viajes[i].fechaBajada)) || f1.getTime() <= (new Date(this.state.viajes[i].fechaSubida)).getTime() && f2.getTime() >= (new Date(this.state.viajes[i].fechaSubida))) {

				newViajes.push({
					key: this.state.viajes[i].key,
					cliente: this.state.viajes[i].cliente,
					empleado: this.state.viajes[i].empleado,
					fechaReserva: this.state.viajes[i].fechaReserva,
					fechaBajada: this.state.viajes[i].fechaBajada,
					fechaSubida: this.state.viajes[i].fechaSubida,
					horaSubida: this.state.viajes[i].horaSubida,
					horaBajada: this.state.viajes[i].horaBajada,
					pago: this.state.viajes[i].pago,
					total: this.state.viajes[i].total,
					lugar: this.state.viajes[i].lugar,
					centro: this.state.viajes[i].centro,
					responsable: this.state.viajes[i].encargado,
					vehiculo: this.state.viajes[i].vehiculo,
					numero_empleado: this.state.viajes[i].nemple,
					numero: 1,
					personas: this.state.viajes[i].cliente,
					desde: this.state.viajes[i].partida,
					tipoV: this.state.viajes[i].tipoV,
					foto: this.state.viajes[i].foto,
					keyEmpleado: this.state.viajes[i].keyEmpleado,
					combinacion: this.state.viajes[i].partida + '-' + this.state.viajes[i].lugar,
					detaCate: '#N/A',
					cantTrayec: 1,
					areaDesc: this.state.viajes[i].areaDesc
				})

			}

		}
		this.setState({

			viajes: newViajes

		})


	}



	mostrarRegistrosHoy() {



		let f1 = new Date(this.state.fecha_actual);
		let f2 = new Date(this.state.fecha_actual);


		let newViajes = []

		this.state.viajes = this.state.viajestemp;
		this.setState({

			viajes: this.state.viajestemp
		})


		for (let i = 0; i < this.state.viajes.length; i++) {


			if (f1.getTime() <= (new Date(this.state.viajes[i].fechaBajada)).getTime() && f2.getTime() >= (new Date(this.state.viajes[i].fechaBajada)) || f1.getTime() <= (new Date(this.state.viajes[i].fechaSubida)).getTime() && f2.getTime() >= (new Date(this.state.viajes[i].fechaSubida))) {

				newViajes.push({
					key: this.state.viajes[i].key,
					cliente: this.state.viajes[i].cliente,
					empleado: this.state.viajes[i].empleado,
					fechaReserva: this.state.viajes[i].fechaReserva,
					fechaBajada: this.state.viajes[i].fechaBajada,
					fechaSubida: this.state.viajes[i].fechaSubida,
					horaSubida: this.state.viajes[i].horaSubida,
					horaBajada: this.state.viajes[i].horaBajada,
					pago: this.state.viajes[i].pago,
					total: this.state.viajes[i].total,
					lugar: this.state.viajes[i].lugar,
					centro: this.state.viajes[i].centro,
					responsable: this.state.viajes[i].encargado,
					vehiculo: this.state.viajes[i].vehiculo,
					numero_empleado: this.state.viajes[i].nemple,
					numero: 1,
					personas: this.state.viajes[i].cliente,
					desde: this.state.viajes[i].partida,
					tipoV: this.state.viajes[i].tipoV,
					foto: this.state.viajes[i].foto,
					keyEmpleado: this.state.viajes[i].keyEmpleado,
					combinacion: this.state.viajes[i].partida + '-' + this.state.viajes[i].lugar,
					detaCate: '#N/A',
					cantTrayec: 1,
					areaDesc: this.state.viajes[i].areaDesc
				})

			}

		}
		this.setState({

			viajes: newViajes

		})


	}

	mostrar = (row) => {
		this.setState({ datosAct: row, modalIsOpen: true });
	}
	mostrar2 = (row) => {
		database.ref('/Empleados/' + row.keyEmpleado).once('value').then(snap => {
			let datos = snap.val();
			datos.placa = row.vehiculo;
			datos.tipoV = row.tipoV;
			database.ref('/Socios/' + datos.socio).once('value').then(snap2 => {
				let valor = snap2.val();
				datos.nombresocio = valor.Nombre + ' ' + valor.Apellido;
				this.setState({ EmpleActu: datos });
			})

		})
		this.setState({ modalIsOpenC: true });
	}

	closeModal = () => {
		this.setState({ modalIsOpen: false })
	}
	closeModal2 = () => {
		this.setState({ modalIsOpenC: false })
	}

	generateBtnRecibo(cell, row) {
		return <button className="btn btn-success btn-sm" onClick={() => { this.mostrar(row) }} >Ver</button>;
	}

	generateVerEmple = (cell, row) => {

		return <button className="btn btn-success btn-sm" onClick={() => { this.mostrar2(row) }} >Conductor</button>;
	}


	render() {


		return (

			<div onClick={this.ocultarMenu}>
				<br />

				<div className="">
					<h1 className="titulo">Viajes</h1>


					<div className="container">
						<div className="row">

							
							<div className="col-md-6 col-sm-6 col-xs-6">
								<ExcelFile filename="Reporte_Viajes.xlsx" element={(<button className="btn btn-success btn-sm excel"><span className="glyphicon glyphicon-download-alt"></span> Descargar Excel </button>)}>

									<ExcelSheet data={this.state.viajes} name="Viajes">
										<ExcelColumn label="Conductor" value="empleado" />
										<ExcelColumn label="Recibo" value="" />
										<ExcelColumn label="Centro de costos" value="centro" />
										<ExcelColumn label="Area de descargue" value="areaDesc" />
										<ExcelColumn label="Responsable de centro de costos" value="responsable" />
										<ExcelColumn label="Unidad" value="vehiculo" />
										<ExcelColumn label="Cantidad de personas por viaje" value="numero" />
										<ExcelColumn label="Nombres (pasajeros)" value="personas" />
										<ExcelColumn label="Fecha subida" value="fechaSubida" />
										<ExcelColumn label="Hora subida" value="horaSubida" />
										<ExcelColumn label="Fecha Bajada" value="fechaBajada" />
										<ExcelColumn label="Hora Bajada" value="horaBajada" />
										<ExcelColumn label="Pago" value="pago" />
										<ExcelColumn label="Desde" value="desde" />
										<ExcelColumn label="Hacia" value="lugar" />
										<ExcelColumn label="Combinacion de rutas" value="combinacion" />
										<ExcelColumn label="Tarifa aplicada" value="tipoV" />
										<ExcelColumn label="Cantidad de trayectos" value="cantTrayec" />
										<ExcelColumn label="Precio aplicado" value="total" />
										<ExcelColumn label="Persona que solicita el servicio" value="cliente" />
										<ExcelColumn label="Codigo de empleado" value="numero_empleado" />
									</ExcelSheet>

								</ExcelFile>

							</div>
						</div>
						<br />
						<div className="row">
							<div className="col-md-4 col-xs-6 col-sm-6">
								<div className=" col-md-6">
									<label>Fecha inicio</label>
									<input type="date" className="form-control" max={this.state.fecha_actual} onChange={this.handleChangeDatePicker1}
										ref={input => { this.fecha1 = input; }}
									/>
								</div>
							</div>

							<div className="col-md-4 col-xs-6 col-sm-6">
								<div className="col-md-6">
									<label>Fecha fin</label>
									<input type="date" className="form-control" max={this.state.fecha_actual} onChange={this.handleChangeDatePicker2}
										ref={input => { this.fecha2 = input; }} disabled={this.state.input_disabled} min={this.state.fecha_minima}
									/>
								</div>
							</div>

							<div className="col-md-4 col-xs-6 col-sm-6">
								<div className="col-md-6">
									<button className="btn btn-primary btn-sm" onClick={this.mostrarRegistrosHoy}>Registros de hoy</button>
								</div>
							</div>

						</div>
					</div>
					<br />



					<div className="container">

						<BootstrapTable data={this.state.viajes}
							printToolBar={true}
							ref='table'
							pagination={true}
							search={true}

						>
							<TableHeaderColumn width={this.state.anchoActual > 600 ? '0' : '150'} dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
							<TableHeaderColumn width={this.state.anchoActual > 600 ? '0' : '150'} dataField='empleado' dataSort={true}>Conductor</TableHeaderColumn>
							<TableHeaderColumn width={this.state.anchoActual > 600 ? '0' : '150'} dataField='empleado' dataAlign='center' dataSort={true} dataFormat={this.generateVerEmple.bind(this)}>ver conductor</TableHeaderColumn>
							<TableHeaderColumn width={this.state.anchoActual > 600 ? '0' : '150'} dataField='ver' dataAlign='center' dataFormat={this.generateBtnRecibo.bind(this)}>Recibo</TableHeaderColumn>
							<TableHeaderColumn width={this.state.anchoActual > 600 ? '0' : '155'} dataField='centro' dataSort={true}>Centro de costos</TableHeaderColumn>
							<TableHeaderColumn width={this.state.anchoActual > 600 ? '0' : '185'} dataField='areaDesc' dataSort={true}>Area de descargue</TableHeaderColumn>
							<TableHeaderColumn width={this.state.anchoActual > 600 ? '0' : '300'} dataField='responsable' dataSort={true}>Responsable de centro de costos</TableHeaderColumn>
							<TableHeaderColumn width={this.state.anchoActual > 600 ? '0' : '155'} dataField='vehiculo' dataSort={true}>Unidad</TableHeaderColumn>
							<TableHeaderColumn width={this.state.anchoActual > 600 ? '0' : '255'} dataField='numero' dataSort={true}>Cantidad de personas por viaje</TableHeaderColumn>
							<TableHeaderColumn width={this.state.anchoActual > 600 ? '0' : '200'} dataField='personas' dataSort={true}>Nombres (pasajeros)</TableHeaderColumn>
							<TableHeaderColumn width={this.state.anchoActual > 600 ? '0' : '150'} dataField='fechaSubida' dataAlign='center' dataSort={true}>Fecha Subida</TableHeaderColumn>
							<TableHeaderColumn width={this.state.anchoActual > 600 ? '0' : '150'} dataField='horaSubida' dataAlign='center' dataSort={true}>Hora subida</TableHeaderColumn>
							<TableHeaderColumn width={this.state.anchoActual > 600 ? '0' : '150'} dataField='fechaBajada' dataAlign='center' dataSort={true}>Fecha Bajada</TableHeaderColumn>
							<TableHeaderColumn width={this.state.anchoActual > 600 ? '0' : '150'} dataField='horaBajada' dataAlign='center' dataSort={true}>Hora bajada</TableHeaderColumn>
							<TableHeaderColumn width={this.state.anchoActual > 600 ? '0' : '150'} dataField='pago' dataAlign='center' dataSort={true}>Pago</TableHeaderColumn>
							<TableHeaderColumn width={this.state.anchoActual > 600 ? '0' : '150'} dataField='desde' dataAlign='center' dataSort={true}>Desde</TableHeaderColumn>
							<TableHeaderColumn width={this.state.anchoActual > 600 ? '0' : '150'} dataField='lugar' dataAlign='center' dataSort={true}>Hacia</TableHeaderColumn>


							<TableHeaderColumn width={this.state.anchoActual > 600 ? '0' : '550'} dataField='combinacion' dataAlign='center' dataSort={true}>Combinacion de rutas</TableHeaderColumn>
							<TableHeaderColumn width={this.state.anchoActual > 600 ? '0' : '150'} dataField='tipoV' dataAlign='center' dataSort={true}>Tarifa aplicada</TableHeaderColumn>
							<TableHeaderColumn width={this.state.anchoActual > 600 ? '0' : '200'} dataField='cantTrayec' dataAlign='center' dataSort={true}>Cantidad de trayectos</TableHeaderColumn>
							<TableHeaderColumn width={this.state.anchoActual > 600 ? '0' : '150'} dataField='total' dataAlign='center' dataSort={true}>Precio aplicado</TableHeaderColumn>
							<TableHeaderColumn width={this.state.anchoActual > 600 ? '0' : '250'} dataField='cliente' dataAlign='center' dataSort={true}>Persona que solicita el servicio</TableHeaderColumn>
							<TableHeaderColumn width={this.state.anchoActual > 600 ? '0' : '180'} dataField='numero_empleado' dataAlign='center' dataSort={true}>Codigo empleado</TableHeaderColumn>
						</BootstrapTable>
						<Modal isOpen={this.state.modalIsOpen} onRequestClose={this.closeModal} contentLabel="Recibo">
							<Report datos={this.state.datosAct} />
							<div className="container">
								<button className="btn btn-default buttons" onClick={this.closeModal}> Cerrar</button>
							</div>
						</Modal>
						<Modal style={customStyles} isOpen={this.state.modalIsOpenC} onRequestClose={this.closeModal2} contentLabel="Empleado">
							<Emple empleado={this.state.EmpleActu} />
						</Modal>
					</div>

				</div>

			</div>
		);

	}


}
export default Viajes;


// WEBPACK FOOTER //
// ./src/Components/Empleados_empresa/Viajes.jsx